import Container from 'react-bootstrap/Container';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';

import  MouseEvent from "react";
import { useState }  from "react";
import { Facebook, Youtube, Tiktok, Instagram } from 'react-bootstrap-icons';

import FormJoinMailingList from '../forms/JoinMailing';
function FooterEngagement(){



    return (
        <> 
            <Container>
                { false &&
                <Row>
                    <FormJoinMailingList />
                </Row>
                }
                <Row className="py-3">
                    <Col><a target="_blank" rel="noopener noreferrer" href="https://www.tiktok.com/@sunsetliq1?_r=1&_t=ZT-96tWWdgnhXi"><Tiktok size={32} color="black"/></a></Col>
                    <Col><a target="_blank" rel="noopener noreferrer" href="https://www.instagram.com/sunset_liq1"><Instagram size={32} color="black" /></a></Col>
                    <Col><a target="_blank" rel="noopener noreferrer" href="https://youtube.com/@sunsetterscommunity?si=9KGoIEJS14scVJew"><Youtube size={32} color="red"/></a></Col>
                    <Col><a target="_blank" rel="noopener noreferrer" href="https://www.facebook.com/share/1FnP8bpiNe/"><Facebook size={32}/></a></Col>

                </Row>

            </Container>
        </>
    );

}

export default FooterEngagement;